const imsStyle = {
  code: {
    width: '60%',
    color: 'gray',
  },
};

export default imsStyle;
